import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Menu } from "primereact/menu";
import { confirmDialog } from "primereact/confirmdialog";
import { InputComponent } from "../InputComponent";
import { TablaDinamica } from "../TablaDinamica";
import * as generic from "../Generico";
import { useLazyParams } from "../../hooks/useLazyParams";
import { CertificacionPais } from "../../models/trust/cliente/CertificacionPais";
import { PaisService } from "../../service/trust/certificacion/PaisService";

export const PaisFiscal = ({ toast, id, catalogos, permss, soloLectura, tipo }) => {

    const omodel = new CertificacionPais();
    const defaultValues = generic.funDefault(omodel.model, null);

    const [dialogVisible, setDialogVisible] = useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
    const menuRef = useRef(null);

    const paisSrv = new PaisService();
    const tablaPais = useLazyParams({ modelo: omodel.model });

    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const { inText, inDrop } = InputComponent({ omodel, errors, control, permss, id: getValues('id'), soloLectura });

    useEffect(() => {
        if (id) loadLazyData();
        // eslint-disable-next-line
    }, [tablaPais.lazyParams, id]);

    const loadLazyData = () => {
        tablaPais.setLoading(true);
        const _params = { ...tablaPais.lazyParams, idp: id, tipo: tipo };
        paisSrv.getLista({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaPais.setTotalRecords(res.data.total);
            tablaPais.setData(res.data.registros);
        }).finally(() => tablaPais.setLoading(false));
    };

    const openNew = () => {
        reset(defaultValues);
        setDialogVisible(true);
    };

    const hideDialog = () => setDialogVisible(false);

    const onSubmit = (data) => {
        data.idp = id;
        data.tipo = tipo;

        const request = getValues('id') == null
            ? paisSrv.nuevo(data)
            : paisSrv.editar(data);

        request.then(res => {
            setDialogVisible(false);
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => generic.funcError(error, toast, setError));
    };

    const editRegistro = (idReg) => {
        paisSrv.consultar(idReg).then(res => {
            const _data = res.data.certificacion_pais;
            reset(generic.renewValues(_data, omodel.model));
            setDialogVisible(true);
        });
    };

    const confirmDelete = (idReg) => {
        confirmDialog({
            message: '¿Está seguro de eliminar este país fiscal?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                paisSrv.eliminar(idReg).then(res => {
                    loadLazyData();
                    generic.funcSuccess(res, toast);
                }).catch(error => generic.funcDeleteError(error, toast));
            }
        });
    };

    const itemsMenu = () => {
        if (soloLectura) {
            return [{
                label: 'Opciones',
                items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editRegistro(registroSeleccionado?.id) }]
            }];
        }
        return [{
            label: 'Opciones',
            items: [
                { label: 'Editar', icon: 'pi pi-pencil', command: () => editRegistro(registroSeleccionado?.id) },
                { label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete(registroSeleccionado?.id) }
            ]
        }];
    };

    const accionesTemplate = (rowData) => (
        <Button
            icon="pi pi-caret-down"
            type="button"
            className="p-button-rounded p-button-success mr-2"
            title="Opciones/Acciones"
            aria-controls="popup_menu_pais_fiscal"
            aria-haspopup
            onClick={(e) => { setRegistroSeleccionado(rowData); menuRef.current.toggle(e); }}
        />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && id && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
            )}
            <span className="text-sm font-semibold text-600 uppercase tracking-wider">
                Listado de Países Fiscales
            </span>
        </div>
    );

    return (
        <div className="componente-pais-fiscal">
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_pais_fiscal" />
            <TablaDinamica modelo={omodel.model} estadoTabla={tablaPais} datos={tablaPais.data} totalRegistros={tablaPais.totalRecords} dataKey="id" acciones={ColumnaAcciones} header={cabeceraTabla()} />

            <Dialog visible={dialogVisible} header={getValues('id') == null ? "Nuevo País Fiscal" : "Editar País Fiscal"} modal className="p-fluid modal-ssize dialog-personalizado" onHide={hideDialog} style={{ width: '500px' }}>
                <form onSubmit={(e) => { e.stopPropagation(); handleSubmit(onSubmit)(e); }}>
                    <div className="formgrid grid px-2">

                        {inDrop('pais', catalogos?.pais, { lab: 'nombre' }, 12)}
                        {inText('identificacion_contribuyente', { icon: 'pi pi-id-card' }, 12)}

                        <div className="col-12 mt-4 flex justify-content-end">
                            {soloLectura ? (
                                <div className="field col">
                                    <Button label="Cerrar" style={{ maxWidth: '120px' }} icon="pi pi-times" type="button" className="p-button-warning" onClick={hideDialog} />
                                </div>
                            ) : (
                                generic.buttonsForms(hideDialog)
                            )}
                        </div>

                    </div>
                </form>
            </Dialog>
        </div>
    );
};
